import React, { useEffect, useState } from 'react';
import { supabase } from '../../lib/supabaseClient'; // Adjust path if needed

const DashboardHome = () => {
  const [userName, setUserName] = useState('');

  useEffect(() => {
    const fetchUser = async () => {
      const {
        data: { user },
        error,
      } = await supabase.auth.getUser();

      if (error) {
        console.error('Error fetching user:', error.message);
        return;
      }

      if (user && user.user_metadata.full_name) {
        setUserName(user.user_metadata.full_name);
      } else {
        setUserName(user.email); // fallback to email
      }
    };

    fetchUser();
  }, []);

  return (
    <div className="bg-white p-6 rounded-xl shadow">
      <h2 className="text-2xl font-semibold text-indigo-700 mb-4">
        Welcome, {userName || 'Guest'}! 👋
      </h2>
      <p className="text-gray-700 mb-4">
        You're making great progress. Here's an overview of your journey so far.
      </p>
    </div>
  );
};

export default DashboardHome;
